import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { DashboardComponent } from './dashboard.component';
import { TransactionHistoryTableComponent } from './transaction-history-table/transaction-history-table.component';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';

export const routes: Routes = [
  {
    path: '',
    // canActivateChild: [AuthorizationService],
    // children: [
    //   {
    //     path: '',
    //     component: TransactionHistoryTableComponent,
    //     data: {
    //       name: 'dashboard'
    //     }
    //   }
    // ]
     children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: DashboardComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'dashboard'
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {}
